import React from 'react';
import { Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Layout components
import NavigationBar from './components/layout/Navbar';
import ProgressBanner from './components/common/ProgressBanner';

// Context
import { ExecutionProvider, useExecution } from './contexts/ExecutionContext';

// Pages
import HomePage from './pages/HomePage';
import CaseAttributionPage from './pages/CaseAttributionPage';
import MessageClassificationPage from './pages/MessageClassificationPage';
import MessageSummarizationPage from './pages/MessageSummarizationPage';
import ProcessVisualizationPage from './pages/ProcessVisualizationPage';
import ProcessGuessingPage from './pages/ProcessGuessingPage';
import CaseHistoryPage from './pages/CaseHistoryPage';
import PromptHistoryPage from './pages/PromptHistoryPage';

// Inner App component that uses the ExecutionContext
function AppContent() {
  const { runningExecution, cancelExecution } = useExecution();

  return (
    <div className="App">
      <NavigationBar />
      {runningExecution && (
        <ProgressBanner
          execution={runningExecution}
          onClose={() => {}} // Progress banner close is now handled by centralized state
          onCancel={cancelExecution}
        />
      )}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/case-attribution" element={<CaseAttributionPage />} />
          <Route path="/message-classification" element={<MessageClassificationPage />} />
          <Route path="/message-summarization" element={<MessageSummarizationPage />} />
          <Route path="/process-visualization" element={<ProcessVisualizationPage />} />
          <Route path="/process-guessing" element={<ProcessGuessingPage />} />
          <Route path="/case-history" element={<CaseHistoryPage />} />
          <Route path="/prompt-history" element={<PromptHistoryPage />} />
        </Routes>
      </main>
    </div>
  );
}

// Main App component with ExecutionProvider
function App() {
  return (
    <ExecutionProvider>
      <AppContent />
    </ExecutionProvider>
  );
}

export default App;
